import { gql } from '@apollo/client';

export const staffLogList = gql`
  query staffMonitoring($date: Date!) {
    staffMonitoring(date: $date) {
      subjects {
        id
        role
        entityId
        physician {
          id
          name
        }
        staffMember {
          id
          name
        }
        anesthesiologist {
          id
          name
        }
        currentLocation {
          room {
            id
            name
            type
          }
          arrivedAt
        }
        arrivedOnSite
        arrivedOnSiteOverride
        leftSite
        leftSiteOverride
      }
    }
  }
`;

export const staffLogItem = gql`
  query staffMemberDetails($id: Long!, $role: String!, $date: Date!) {
    staffMemberIncludingVoided(id: $id) {
      id
      staffId
      name
      title
      phoneNumber
      email
      hstId
      hasScheduleAccess
      scheduleAccessAll
      compensation
      hourlyRate
      employment
      otherSpecialties
    }
    staffMonitoringById(id: $id, role: $role, date: $date) {
      entries {
        roomId
        entityId
        setAt
        room {
          id
          name
        }
      }
    }
  }
`;

export default {
  list: staffLogList,
  item: staffLogItem,
};
